import { useTranslation } from "@opendash/i18n";
import { Form, Select } from "antd";
import React from "react";
import { useMappedParseFields } from "../hooks/useMappedParseFields";

export default () => {
  const fields = useMappedParseFields(true);
  const t = useTranslation();

  return (
    <Form.Item name="keys" label={t("openware:parse.form.keys.label")}>
      <Select
        mode="multiple"
        options={fields
          .sort((a, b) => {
            return a.field.localeCompare(b.field);
          })
          .map((f) => ({
            label: f.field,
            value: f.field,
            type: f.type,
          }))}
      />
    </Form.Item>
  );
};
